import React, { useEffect, useState } from 'react'
import api from '../components/api'
import { dataTableRender } from '../components/functions'
import { useHistory, Link } from 'react-router-dom'


const FaleConosco = () => {

    const history = useHistory()

    var [resultado, setResultado] = useState()
    var [situacao, setSituacao] = useState('U')

    var [totalRecentes, setTotalRecentes] = useState(0)
    var [totalPendentes, setTotalPendentes] = useState(0)
    var [totalRespondidas, setTotalRespondidas] = useState(0)
    var [totalGeral, setTotalGeral] = useState(0)


    var [busca, setBusca] = useState()
    var [resultadoBusca, setResultadoBusca] = useState()


    async function buscar() {

        var dataPost = {

            busca: busca,

        }


        api.post(`faleConoscoBusca`, dataPost).then((result) => {

            console.log(result.data)

            setResultadoBusca(result.data.map((rs) =>
            
                <li>
                    <Link to={`/FaleConosco/${rs.faleConosco_id}`}>[{rs.dataHora}] [{rs.organizacao}]</Link><br/>  {rs.assunto_descri} - {rs.nome}<br/><br/>
                </li>
            
            ))

        }).catch((err) => {

            console.log(err)

        })


    }

    async function carregaMensagens() {

        //setResultado()


        await api.get(`faleConoscoLista/${situacao}`).then((result) => {

            setResultado(result.data.map((rs) =>
            
                <tr style={{ cursor: 'pointer'}} onClick={() => history.push(`/FaleConosco/${rs.faleConosco_id}`)}>
                    <td style={{ width: '80px'}} key={rs.faleConosco_id}>
                        <center>
                        {rs.dataHoraBanco}
                        </center>
                    </td>
                    <td>
                        {rs.nome}
                    </td>
                   
                    <td>
                        {rs.assunto_descri}
                    </td>
                    <td style={{  backgroundColor: rs.resolvido == true ? '#b4f0a3' : '#f0ada3'}}>
                        <center>{rs.resolvido == true ? 'Sim' : 'Não'}</center>
                    </td>
                </tr>
            
            ))

            dataTableRender(`tabela${situacao}`)

        }).catch((err) => {

            console.log(err.response)

        })

    }



    async function faleConoscoTotal() {


        await api.get('faleConoscoTotal').then((result) => {

            //console.log(result.data)

            var data = result.data[0]

            setTotalGeral(data.totalGeral)
            setTotalPendentes(data.totalPendentes)
            setTotalRecentes(data.totalRecentes)
            setTotalRespondidas(data.totalRespondidas)

        }).catch((err) => {

            console.log(err.response)

        })


    }


    useEffect(() => {

        if (situacao) {

            carregaMensagens()
            faleConoscoTotal()

        }
        
    }, [situacao])


    return (

        <div>
            <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-pin'></i>
                </div>
                <div class='header-title'>
                    <h1>Comunicação</h1>
                    <small>Fale Conosco</small>
                    
                </div>
            </div>



            <div className="row">

                
                <ul className="nav nav-tabs">
                    <li className="active"><Link to="#tab1" data-toggle="tab" onClick={() => setSituacao('U')}>Recentes ({totalRecentes})</Link></li>
                    <li ><Link to="#tab2" data-toggle="tab"  onClick={() => setSituacao('P')}>Não respondidas ({totalPendentes})</Link></li>
                    <li ><Link to="#tab3" data-toggle="tab"  onClick={() => setSituacao('R')}>Respondidas ({totalRespondidas})</Link></li>
                    <li ><Link to="#tab4" data-toggle="tab"  onClick={() => setSituacao('G')}>Todas ({totalGeral})</Link></li>
                    <li ><Link to="#tab5" data-toggle="tab" >Buscar pelo texto</Link></li>
                    
                    
                </ul>
                        
                <div class="tab-content">
                    <div class="tab-pane fade in active" id="tab1">
                        <div class="panel-body">


                        
                                    
                            <div className="table-responsive">
                                <table id="tabelaU" className="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>

                                            <th style={{ width: '80px'}}><center>Data/Hora</center></th>
                                            <th>Nome</th>
                                           
                                            <th>Assunto</th>
                                            <th>Resolvido</th>
                                          
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resultado}
                                    </tbody>
                                    
                                </table>
                            </div>
                                
                        


                        </div>
                    </div>
                    
                    <div className="tab-pane fade in" id="tab2">
                        <div className="panel-body">

                            <div className="table-responsive">
                                <table id="tabelaP" className="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>

                                            <th style={{ width: '80px'}}><center>Data/Hora</center></th>
                                            <th>Nome</th>
                                           
                                            <th>Assunto</th>
                                            <th>Resolvido</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resultado}
                                    </tbody>
                                    
                                </table>
                            </div>



                        </div>

                    </div>


                    <div className="tab-pane fade in" id="tab3">
                        <div className="panel-body">

                            <div className="table-responsive">
                                <table id="tabelaR" className="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>

                                            <th style={{ width: '80px'}}><center>Data/Hora</center></th>
                                            <th>Nome</th>
                                            
                                            <th>Assunto</th>
                                            <th>Resolvido</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resultado}
                                    </tbody>
                                    
                                </table>
                            </div>



                        </div>

                    </div>


                    <div className="tab-pane fade in" id="tab4">
                        <div className="panel-body">

                            <div className="table-responsive">
                                <table id="tabelaG" className="table table-bordered table-striped table-hover">
                                    <thead>
                                        <tr>

                                            <th style={{ width: '80px'}}><center>Data/Hora</center></th>
                                            <th>Nome</th>
                                            
                                            <th>Assunto</th>
                                            <th>Resolvido</th>
                                          
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resultado}
                                    </tbody>
                                    
                                </table>
                            </div>



                        </div>

                    </div>

                    <div className="tab-pane fade in" id="tab5">
                        <div className="panel-body">

                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>Palavra-chave para busca</label>
                                    <input type="text"  placeholder="Informe aqui..." className="form-control" value={busca} onChange={event => setBusca(event.target.value)} />
                                                    
                                </div>
                            </div>
                            <div className="col-md-12">
                            <button type="button" class="btn btn-info" onClick={() => buscar()}>Buscar</button>&nbsp;
                            </div>

                            

                            <div className="col-md-12">
                                <br/><br/>
                                <ul>
                                {resultadoBusca}
                                </ul>


                            </div>



                        </div>

                    </div>

                    
                </div>


                
            </div>

        


        </div>

    )


}


export default FaleConosco